import React, { useEffect, useRef, useState } from 'react'
import { Box, Button, Modal, Typography } from '@mui/material'

import DeleteButton from './DeleteButton'
import FroalaEditorComponent, { FroalaEditorRef } from './RichTextEditor'

interface FroalaEditorModalProps {
  open: boolean
  onClose: () => void
  onSave: (content: string) => void
  onDelete?: () => void
  initialContent: string
  itemName?: string
  title?: string
}

const FroalaEditorModal: React.FC<FroalaEditorModalProps> = ({
  open,
  onClose,
  onSave,
  onDelete,
  initialContent,
  itemName = 'Content',
  title = 'Edit Content',
}) => {
  const [content, setContent] = useState(initialContent)
  const editorRef = useRef<FroalaEditorRef>(null)

  useEffect(() => {
    if (open) {
      setContent(initialContent)
    }
  }, [open, initialContent])

  const handleEditorChange = (newContent: string): void => {
    setContent(newContent)
  }

  const handleSave = (): void => {
    onSave(content)
    onClose()
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby='froala-editor-modal-title'
      aria-describedby='froala-editor-modal-description'
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '80%',
          maxWidth: 800,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
        }}
      >
        <Box className='flex-va-align' display='flex' justifyContent={'space-between'}>
          <Typography id='froala-editor-modal-title' variant='h6' component='h2' gutterBottom>
            {title}
          </Typography>
          {onDelete && (
            <DeleteButton
              item={title}
              onDelete={onDelete}
              warningMessage={'Are you sure you want to delete this ' + itemName + '?'}
            />
          )}
        </Box>
        <Box sx={{ mb: 2 }}>
          <FroalaEditorComponent
            ref={editorRef}
            height={300}
            maxHeight={500}
            initialContent={content}
            onChange={handleEditorChange}
          />
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Button onClick={onClose} variant='outlined' color='secondary'>
            Cancel
          </Button>
          <Button onClick={handleSave} variant='contained' color='secondary'>
            Save
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}

export default FroalaEditorModal
